var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from 'utils/apis/api';
export const webformEndpointsApi = api
    .enhanceEndpoints({
    addTagTypes: ['WebformEndpoint'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        readWebformEndpoints: builder.query({
            query: () => ({
                version: 1,
                path: 'webform-endpoints',
            }),
            providesTags: (result, _error, _arg) => result
                ? [
                    ...result.data.endpoints.map(({ id }) => ({
                        type: 'WebformEndpoint',
                        id,
                    })),
                    'WebformEndpoint',
                ]
                : ['WebformEndpoint'],
        }),
        createWebformEndpoint: builder.mutation({
            query: (body) => ({
                version: 1,
                method: 'POST',
                path: 'webform-endpoints',
                body,
            }),
            onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const response = yield queryFulfilled;
                    dispatch(webformEndpointsApi.util.updateQueryData('readWebformEndpoints', undefined, (draft) => {
                        const endpoints = draft.data.endpoints;
                        endpoints.push(response.data.data);
                        endpoints.sort((a, b) => a.id.localeCompare(b.id));
                    }));
                });
            },
        }),
        deleteWebformEndpoint: builder.mutation({
            query: ({ webformId }) => ({
                version: 1,
                method: 'DELETE',
                path: `webform-endpoints/${webformId}`,
            }),
            onQueryStarted({ webformId }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchResult = dispatch(webformEndpointsApi.util.updateQueryData('readWebformEndpoints', undefined, (draft) => {
                        const endpoints = draft.data.endpoints;
                        endpoints.splice(endpoints.findIndex(({ id }) => id === webformId), 1);
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchResult.undo();
                    }
                });
            },
        }),
    }),
});
